import { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  TableContainer,
  TableContent,
  TABLE_LAYOUT_OPTIONS,
  usePreventTableScrollingRef,
} from "cdk-radial";

const apiNameRenderer = ({ value }) => (
  <div className="api-name-renderer">{value || "N/A"}</div>
);

const apiNameHeaderRenderer = () => (
  <div className="api-name-header-renderer">API Names</div>
);

export default function BundleApisTable({ selectedApis = [] }) {
  const [data, setData] = useState([]);
  const gridRef = useRef();
  const tableContentRef = usePreventTableScrollingRef();

  const columns = [
    {
      cellRendererFramework: apiNameRenderer,
      field: "apiName",
      headerComponentFramework: apiNameHeaderRenderer,
      width: 289,
    },
  ];

  useEffect(() => {
    const tableData = [];
    selectedApis.forEach((api) => {
      tableData.push({
        apiName: api?.api_name,
      });
    });
    setData(tableData);
  }, [selectedApis]);

  const handleGridReady = (gridParams) => {
    gridParams.api.sizeColumnsToFit();
    gridParams.api.refreshCells({
      force: true,
    });
  };

  return (
    <TableContainer id="ag-grid-container-bundle-apis" className="ag-theme-balham">
      <TableContent
        data-testid="table-content"
        className="create-bundle-table-content"
        ref={tableContentRef}
      >
        <AgGridReact
          className="bundle-api-ag-grid-table"
          columnDefs={columns}
          domLayout={TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT}
          rowData={data}
          rowHeight={32}
          style={{ width: "100%" }}
          ref={gridRef}
          onGridReady={handleGridReady}
          suppressRowClickSelection={true}
        />
      </TableContent>
    </TableContainer>
  );
}
